import React from "react";
import Head from "next/head";
import { DefaultSeo, NextSeo } from "next-seo";
import type { NextSeoProps } from "next-seo/lib/types";
export const PageHead: React.FunctionComponent<{
  pageSeo?: NextSeoProps;
}> = ({
  pageSeo
}) => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="PageHead.tsx">
        <meta charSet="utf-8" data-sentry-element="meta" data-sentry-source-file="PageHead.tsx" />
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no" data-sentry-element="meta" data-sentry-source-file="PageHead.tsx" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <DefaultSeo titleTemplate="%s | Akash Console" defaultTitle="Akash Console" description="Akash Console is the #1 platform to deploy docker containers on the Akash Network, a decentralized super cloud compute marketplace. Explore, deploy and track all in one place!" openGraph={{
      type: "website",
      locale: "en_US",
      url: "https://console.akash.network/",
      site_name: "Akash Console",
      description: "Deploy docker containers on the decentralized supercloud Akash Network.",
      images: [{
        url: "https://console.akash.network/akash-console.png",
        width: 1200,
        height: 630,
        alt: "AkashConsole Cover Image"
      }]
    }} twitter={{
      handle: "@akashnet",
      site: "@akashnet",
      cardType: "summary_large_image"
    }} data-sentry-element="DefaultSeo" data-sentry-source-file="PageHead.tsx" />

      <NextSeo {...pageSeo} data-sentry-element="NextSeo" data-sentry-source-file="PageHead.tsx" />
    </>;
};